import React, { useState } from 'react'
import Modal from "./Modal"
import { useHistory } from 'react-router-dom'
import axios from "axios"
import style from "../style/components/forgot.module.css"
import { Link, useLocation } from 'react-router-dom';


const ForgotPass = () => {
  const history = useHistory();
const [step, setStep] = useState("enterEmail");
const [email, setEmail] = useState("");
const [code, setCode] = useState("");
const [newPassword, setNewPassword] = useState("");
let location = useLocation();

  
  const handleRequestCode = async (e) => {
  e.preventDefault();
  try {
    await axios.post("https://rishat-tour.ru/api/auth/forgot-password", { email });
    setStep("enterCode");
  } catch (e) {
    alert("Ошибка при отправке кода");
  }
};

const handleCheckCode = async (e) => {
  e.preventDefault();
  try {
    await axios.post("https://rishat-tour.ru/api/auth/verify-reset-code", { email, code });
    setStep("newPassword");
  } catch (e) {
    alert("Неверный код");
  }
};

const handleResetPassword = async (e) => {
  e.preventDefault();
  try {
    await axios.post("https://rishat-tour.ru/api/auth/reset-password-code", { email, code, newPassword });
    alert("Пароль изменён, войдите с новым");
    history.push("/");
  } catch (e) {
    alert("Ошибка при смене пароля");
  }
};

  return (
    <Modal onClose={() => history.push("/")}>
<form className={style.wrap} onSubmit={
  step === "enterEmail"
    ? handleRequestCode
    : step === "enterCode"
    ? handleCheckCode
    : handleResetPassword
}>
  {step === "enterEmail" && (
    <>
      <h1>Введите email</h1>
      <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
      <button type="submit">Получить код</button>
    </>
  )}

  {step === "enterCode" && (
    <>
      <h1>Введите код из письма</h1>
      <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="Код" />
      <button type="submit">Проверить</button>
    </>
  )}

  {step === "newPassword" && (
    <>
      <h1>Введите новый пароль</h1>
      <input
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        placeholder="Новый пароль"
      />
      <button type="submit">Сменить пароль</button>
    </>
  )}
</form>

    </Modal>
  )
}

export default ForgotPass